import { useState, useContext, createContext } from "react";

const TeacherContext = createContext(null);

export const useTeacherContext = () => useContext(TeacherContext)

function TeacherCVContextProvider({ children }) {
    const [selectedTeacher, setSelectedTeacher] = useState(null);

    return (
        <TeacherContext.Provider value={{ selectedTeacher, setSelectedTeacher }}>
            {children}
        </TeacherContext.Provider>
    );
}

export default TeacherCVContextProvider;
